var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('popup',{attrs:{"is-set-styled":false,"is-btn-close":false,"show":_vm.popups.pdfViewer.show,"name":_vm.popups.pdfViewer.name,"add-class":'pdf-viewer__wrapper'}},[_c('pdf-viewer',{attrs:{"files":_vm.files}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }